export const ALIGNMENT_OPTIONS: Record<string, string> = {
  '0': 'left',
  '1': 'center',
  '2': 'right',
};
